import {
  InputValidationMeteorError,
  parseInputValidationErrorDetails,
} from 'server/shared/models/inputValidationError';

export function logInputValidationError({
  error,
  input,
}: {
  error: InputValidationMeteorError;
  input?: unknown;
}): void {
  const details = parseInputValidationErrorDetails(error);
  const method = details?.method || 'unknown';

  console.error(`${method} validation error`, {
    reason: error.reason,
    details,
    input,
  });
}
